import {sliceTailSlash} from './NavUtil';

export function viewable(user, pathname) {
  pathname = sliceTailSlash(pathname);

  if (
    ['/organization', '/user', '/balance_record', '/credential'].includes(
      pathname,
    )
  ) {
    return user?.ext?.level === 'root';
  } else {
    return true;
  }
}

export function editable(user) {
  return user?.ext?.level === 'root';
}
